import theme from 'src/styles/theme'
import styled, { css } from 'styled-components'

export const ConfirmationWrapp = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: ${theme.colors.green2};
  padding: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  width: fit-content;
`

export const MovementsList = styled.div<{ listSize: number }>`
  display: flex;
  flex-direction: column;
  max-height: 512px;
  width: 100%;
  gap: 8px;
  
  ${({ listSize }) => (listSize > 1 && css`
    overflow-y: scroll;
    padding-right: 4px;

    ::-webkit-scrollbar { width: 8px; }
    ::-webkit-scrollbar-track { background: ${theme.colors.confirmHover}; }
    ::-webkit-scrollbar-thumb { background: ${theme.colors.gray4}; }
  `)}
`

export const Card = styled.div`
  border-radius: 8px;
  background-color: ${theme.colors.white};
  padding: 8px;
  width: 100%;
`

export const ActionArea = styled.div<{ hasError?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: ${({ hasError }) => (hasError ? 'center' : 'space-between')};
`
